
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-insights",
      function () {
        return require("private-next-pages/content-insights/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-insights"])
      });
    }
  